import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { Helmet } from 'react-helmet';
import { withRouter } from 'react-router-dom';
import ReactTooltip from 'react-tooltip';
import { List } from 'immutable';

import {ADFOX, APARTMENTS, COMPLEX, SALE, VIEW_MODE} from '../../../consts';
import { RESIDENTIAL_COMPLEX } from '../../../utils/aliases';
import {
  fetchPremiumAnnouncement,
  fetchPremiumResidentialComplex,
  fetchPremiumCottageComplex,
  fetchArticleWidget,
  fetchMeta,
  loadDomains,
  getCianRedirectUrl,
} from '../actions';
import {
  fetchAgencies,
  loadCountAnnouncement,
  updateFilter,
  updateAutocompleteOptions,
} from '../../Search/actions'
import { getUser } from '../../User/actions';
import { setSection } from '../../Dictionaries/actions';
import getDictionary from '../../../utils/dictionaries';
import { getSearchUrl, getLocationByFilter } from '../../../utils/urls';
import { ScrollToTopOnMount } from '../../../ui/Common';
import PremiumAnnouncement from '../../../classes/announcement/premiumAnnouncement';
import PremiumResidentialComplex from '../../../classes/announcement/residentialComplex';
import PremiumCottageComplex from '../../../classes/announcement/cottageComplex';
import Article from '../../../classes/common/article';
import connectDataFetchers from '../../../lib/connectDataFetchers';

import HomeSectionMenu from '../../../ui/Menu/HomeSectionMenu';
import AliasMenu from '../../../ui/Menu/AliasMenu';
import ServicesMenu from '../../../ui/Menu/ServicesMenu';
import { HexaSlider } from '../../../ui/Sliders';
import { PremiumItem } from '../../../ui/Views/Announcements/CardItems';
import { PremiumComplexItem } from '../../../ui/Views/Complex/CardItems';
import { HexaItem as ArticleItem } from '../../../ui/Views/Article/CardItems';
import { AdFoxTile as BuilderSuggestion, BrandedCover, SeoText, AdFoxWideScreen } from '../../../ui/Widgets';
import SelectCity from '../../../ui/SelectCity/SelectCity';
import {sendEvent} from '../../../utils/yandexMetrika';
import { DEFAULT_FILTER } from '../../Search/filter';
import { gtagPushEventNewPage } from '../../../utils/googleAnalytics';
import GtagBuilder from '../../../classes/builder/gtagEventBuilder';


class Home extends Component {
  constructor (props) {
    super(props);

    this.state = {
      /* выбранные параметра фильтра */
      filter: DEFAULT_FILTER.map((_, key) => props.filter.get(key)),
      /* предыдущее значение фильтра - для минимизации рендера */
      prevFilter: props.filter
    };

    this.dealType = props.dealType;
    this.realtyType = props.realtyType;
    this.seoTitle = props.defaultSeoTitle;
    this.seoDescription = props.defaultSeoDescription;
    this.domain = props.domain;

    this.regionName = props.domain.get('domain', '') || '';
  }

  componentDidMount () {
    this.props.setSection(this.dealType, this.realtyType);
    const cianGtagEvent = new GtagBuilder({})
      .setEvent('newpage')
      .setEventCategory('page')
      .setEventAction('newpage')
      .setEventLabel('open')
      .setUser(this.props.user)
      .setPage({
        pageType: 'Home',
        siteType: 'desktop'
      })
      .getEvent();
    gtagPushEventNewPage(cianGtagEvent);
  }

  componentDidUpdate (prevProps, prevState, prevContext) {
    ReactTooltip.rebuild();
  }

  getPremium () {
    const dictionary = this.props.dictionary;
    const items = this.props.premium.getIn([this.dealType + '_' + this.realtyType, 'items']);
    return items.map(item => new PremiumAnnouncement(item, dictionary));
  }

  getArticles () {
    const items = this.props.articles.get('items');
    return items.map(item => new Article(item));
  }

  getPremiumComplex () {
    const type = this.props.complexType;
    const items = this.props.complex.getIn([type, 'items']);

    switch (type) {
      case COMPLEX.residential:
        return items.map(item => new PremiumResidentialComplex(item));
      case COMPLEX.cottage:
        return items.map(item => new PremiumCottageComplex(item));
      default:
        return new List();
    }
  }

  renderSeo () {
    const { meta } = this.props;
    const title = meta && meta.getIn(['data', 'title'], this.seoTitle);
    const description = meta && meta.getIn(['data', 'description'], this.seoDescription);
    const keywords = meta && meta.getIn(['data', 'keywords'], '');

    return (
      <Helmet
        htmlAttributes={{ lang: 'ru' }}
        title={title}
        meta={[
          {
            'name': 'description',
            'content': description
          }, {
            'name': 'keywords',
            'content': keywords
          }
        ]}
      />
    );
  }

  render () {
    const QuickSearch = this.props.quickSearch;
    const pageText = this.props.meta.getIn(['data', 'text']);
    const {
      dealType,
      realtyType,
      user,
      domain,
      dispatch,
      dictionary,
      filteredOfferCount,
      agenciesList,
      loadCountAnnouncement,
      updateFilter,
      setSection,
      premiumTitle,
      premium,
      complexType,
      complexTitle,
      complex,
      builderSuggestion,
      articles,
      selectedOptions,
      updateAutocompleteOptions,
      cianServices
    } = this.props;

    const { filter, prevFilter } = this.state;

    return (
      <div className='home-page'>
        { this.renderSeo() }
        <ScrollToTopOnMount />
        <AdFoxWideScreen
          position={ADFOX.topWideScreenHome}
          regionName={this.regionName}
          dealType={dealType}
          realtyType={realtyType}
        />

        <div className='filter-section'>
          <div className='filter-section__search-wrp'>
            <h1>Главное — знать, где искать!</h1>

            <div className='filter-section__select-city'>
              <SelectCity />
            </div>

            <HomeSectionMenu
              dealType={dealType}
              realtyType={realtyType}
            />

            <QuickSearch
              user={user}
              domain={domain}
              filter={filter}
              prevFilter={prevFilter}
              dispatch={dispatch}
              dictionary={dictionary}
              offerCount={filteredOfferCount}
              agenciesList={agenciesList}
              loadCountAnnouncement={loadCountAnnouncement}
              updateFilter={updateFilter}
              dealType={this.dealType}
              realtyType={this.realtyType}
              setSection={setSection}
              selectedOptions={selectedOptions}
              updateAutocompleteOptions={updateAutocompleteOptions}
            />

          </div>
          <div className={`filter-section__bg filter-section__${dealType}-${realtyType}`} />
        </div>

        {
          cianServices && (
            <ServicesMenu />
          )
        }

        <AliasMenu
          regionName={this.regionName}
          dealType={dealType}
          realtyType={realtyType}
        />

        <HexaSlider
          title={premiumTitle}
          wrapperClassName='premium-announcement'
          cardItemClass={PremiumItem}
          regionName={this.regionName}
          dealType={dealType}
          realtyType={realtyType}
          loading={premium.getIn([this.dealType + '_' + this.realtyType, 'loading'])}
          items={this.getPremium()}
          btnLink={getSearchUrl(dealType, realtyType)}
          btnLabel='Все объявления'
        />

        {
          complexType && (
            <HexaSlider
              title={complexTitle}
              wrapperClassName={'premium-complex ' + complexType}
              cardItemClass={PremiumComplexItem}
              regionName={this.regionName}
              dealType={dealType}
              realtyType={realtyType}
              adfoxPosition={ADFOX.homeSlider_2}
              loading={complex.getIn([complexType, 'loading'])}
              items={this.getPremiumComplex()}
              btnLink={RESIDENTIAL_COMPLEX}
              btnLabel='Все новостройки'
            />
          )
        }

        {
          builderSuggestion && (
            <BuilderSuggestion
              regionName={this.regionName}
              dealType={dealType}
              realtyType={realtyType}
            />
          )
        }

        <HexaSlider
          title='Статьи и новости'
          wrapperClassName='article-section'
          cardItemClass={ArticleItem}
          regionName={this.regionName}
          dealType={dealType}
          realtyType={realtyType}
          loading={articles.get('loading')}
          items={this.getArticles()}
          btnLink='/articles/'
          btnLabel='Все новости'
        />

        {
          pageText && (
            <div className='page-seo-text-home'>
              { <SeoText text={pageText} /> }
            </div>
          )
        }
      </div>
    );
  }
}

Home.propTypes = {
  quickSearch: PropTypes.func.isRequired,
  domain: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  filter: PropTypes.object.isRequired,

  articles: PropTypes.object.isRequired,
  premium: PropTypes.object.isRequired,
  complex: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  complexType: PropTypes.string,
  complexTitle: PropTypes.string,
  premiumTitle: PropTypes.string,

  builderSuggestion: PropTypes.bool,
  cianServices: PropTypes.bool,

  dispatch: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  dealType: PropTypes.string.isRequired,
  realtyType: PropTypes.string.isRequired,
  defaultSeoTitle: PropTypes.string,
  defaultSeoDescription: PropTypes.string,
  dictionary: PropTypes.object.isRequired,
  setSection: PropTypes.func.isRequired,

  agenciesList: PropTypes.object.isRequired,
  fetchAgencies: PropTypes.func.isRequired,
  loadCountAnnouncement: PropTypes.func.isRequired,
  updateFilter: PropTypes.func.isRequired,
  selectedOptions: PropTypes.array.isRequired,
  updateAutocompleteOptions: PropTypes.func.isRequired,
};

Home.defaultProps = {
  defaultSeoTitle: 'Поиск объявлений',
  defaultSeoDescription: 'Поиск объявлений',
  premiumTitle: 'Премиум-объявления',
  complexType: null,
  complexTitle: '',
  builderSuggestion: false,
  selectedOptions: [],
  cianServices: false
};

function mapStateToProps (state) {
  const search = state.get('search');
  const home = state.get('home');

  return {
    articles: home.get('articles'),
    premium: home.get('premium'),
    complex: home.get('complex'),
    meta: home.get('meta'),
    domain: state.get('domain'),
    user: state.get('user'),
    filter: search.get('filter'),
    dictionary: getDictionary(state.get('dictionaries')),
    agenciesList: search.get('agenciesList'),
    filteredOfferCount: search.get('filteredOfferCount') || 0,
    selectedOptions: search.get('selectedOptions').toJS() || [],
  };
}

function mapDispatchToProps (dispatch) {
  const actions = bindActionCreators({
    setSection,
    fetchAgencies,
    loadCountAnnouncement,
    updateFilter,
    updateAutocompleteOptions,
  }, dispatch);

  actions.dispatch = dispatch;
  return actions;
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(
  connectDataFetchers(Home, [getUser, fetchPremiumAnnouncement, fetchMeta, fetchArticleWidget, fetchAgencies, loadDomains, getCianRedirectUrl])
));

export const HomeResidentialComplex = withRouter(connect(mapStateToProps, mapDispatchToProps)(
  connectDataFetchers(Home, [getUser, fetchPremiumAnnouncement, fetchMeta, fetchArticleWidget, fetchPremiumResidentialComplex, fetchAgencies, loadDomains, getCianRedirectUrl])
));

export const HomeCottageComplex = withRouter(connect(mapStateToProps, mapDispatchToProps)(
  connectDataFetchers(Home, [getUser, fetchPremiumAnnouncement, fetchMeta, fetchArticleWidget, fetchPremiumCottageComplex, fetchAgencies, loadDomains, getCianRedirectUrl])
));



// WEBPACK FOOTER //
// ./src/app/Home/components/Home.jsx